export default "__VITE_ASSET__0a8ee7d4__"